module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Listofplates"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of Plates")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Evolution"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Evolution of the KGB 1917–2017")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Abbreviations"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abbreviations and Acronyms")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Transliteration"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Transliteration of Russian Names")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Foreword"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword and Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction: From the Okhrana to the National Guard")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 1")]), _vm._v(" Origins of the Cheka")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 2")]), _vm._v(" Lenin, Trotsky, and His Majesty’s Secret Service")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Russian Civil War, Foreign Intervention, the Fate of the Romanovs, and British-American Intelligence")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 4")]), _vm._v(" Comintern: Secret Soldiers of the Revolution")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 5")]), _vm._v(" The Looting of Russia")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 6")]), _vm._v(" Disinformburo and Early Deception Operations")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 7")]), _vm._v(" First ‘Illegals’ and ‘Rezidents’")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 8")]), _vm._v(" Trade, Diplomacy and Famine")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 9")]), _vm._v(" The Raids")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 10")]), _vm._v(" The Russians are Coming")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 11")]), _vm._v(" Soviet House, British Spy Mania and SIS Activities in Russia: The ARCOS Tangle")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocbt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix: Lenin and the Cheka")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Recommended Reading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0